import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, FormArray, FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, catchError, throwError } from 'rxjs';
import { config } from 'src/app/config/config';
import { ForexDerivativesService } from 'src/app/service/forex-derivatives.service';
import { RateDerivativesService } from 'src/app/service/rate-derivatives.service';
import { UserDetailsService } from 'src/app/service/user-details.service';
declare var $: any;

@Component({
  selector: 'app-float-interest',
  templateUrl: './float-interest.component.html',
  styleUrls: ['./float-interest.component.css'],
  viewProviders: [{
    provide: ControlContainer, useExisting: FormGroupDirective
  }]
})
export class FloatInterestComponent implements OnInit, OnChanges {

  floatInterestPayRecForm: FormGroup;
  dayCountFractionList: any = ['ACT/ACT', 'ACT/360', '30/360', '30/365', 'ACT/365'];
  designatedMaturityList: any = []
  floatInterestFormGroupName: string;
  config: any = config;
  currencyList: any = [];
  paymentFreqList: any = ['1M', '2M', '3M', '6M', '12M', 'BULLET'];
  resetDateSpecList: any = ['First', 'Other (OIS)', 'Last'];
  compoundingTypeSpreadArray: any = ['Compounding', 'Flat'];
  interpolationOfStubArray: any = [];
  bsValue: any = [];
  paymentData: any = [];
  benchmarkList: any = [];
  dropDownData: any = [];

  @Input() swapType: String;
  @Input() interestPayRec: string;
  @Input() irsFormData: any = {};
  @Input() action: string;
  @Input() currencyCode: string = "";
  @Output() formUpdateInt = new EventEmitter<{ formData: FormGroup, interestPayRec: string }>();

  constructor(private formBuilder: FormBuilder,
    private userDetailsService: UserDetailsService,
    private cdref: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private fgd: FormGroupDirective,
    private forexService: ForexDerivativesService,
    private toastr: ToastrService,
    private rateService: RateDerivativesService) { }

  ngOnInit(): void {

    // this.floatInterestPayRecForm = this.formBuilder.group({
    //   backwrdEffDateFlg: ['N', Validators.required],
    //   floatRateBenchMark: ['', Validators.required],
    //   effectiveDate: ['', Validators.required],
    //   designatedMaturity: ['', Validators.required],
    //   resetDateSpec: ['', Validators.required],
    //   spread: ['', Validators.required],
    //   dayCountFraction: ['', Validators.required],
    //   premCurncyCode: ['', Validators.required],
    //   premPaymntDate: ['', Validators.required],
    //   premPAmtPayRecv: ['', Validators.required],
    //   stub: ['N', Validators.required],
    //   noOfRepetition: ['', Validators.required],
    //   paymentFreqncy: ['', Validators.required],
    //   floatPaymentSchedule: this.formBuilder.array([])
    // });
    this.getCurrencyList();
    // this.fgd.form.addControl('floatInterest', this.floatInterestPayRecForm);
  }

  ngOnChanges(changes: SimpleChanges): void {
    let intData;
    this.getCurrencyList();
    if (this.swapType == 'FLFX' || (this.swapType == 'FLFL' && this.interestPayRec == 'pay')) {
      intData = this.irsFormData.floatInterestPayable;
      this.floatInterestFormGroupName = 'floatInterestPayable';
    } else if (this.swapType == 'FXFL' || (this.swapType == 'FLFL' && this.interestPayRec == 'receive')) {
      intData = this.irsFormData.floatInterestReceivable;
      this.floatInterestFormGroupName = 'floatInterestReceivable';
    }
    this.floatInterestPayRecForm = this.formBuilder.group({
      backwrdEffDateFlg: [intData?.backwrdEffDateFlg || 'N', Validators.required],
      floatRateBenchMark: [intData?.floatRateBenchMark || '', Validators.required],
      effectiveDate: [intData?.effectiveDate ? new Date(intData?.effectiveDate) : '', Validators.required],
      designatedMaturity: [intData?.designatedMaturity || '', Validators.required],
      resetDateSpec: [intData?.resetDateSpec || '', Validators.required],
      spread: [intData?.spread || ''],
      compoundingTypeSpread: [intData?.compoundingTypeSpread || ''],
      dayCountFraction: [intData?.dayCountFraction || '', Validators.required],
      premCurncyCode: [intData?.premCurncyCode || ''],
      premPaymntDate: [intData?.premPaymntDate ? new Date(intData?.premPaymntDate) : ''],
      premPAmtPayRecv: [intData?.premPAmtPayRecv || 0],
      stub: [intData?.stub || 'N', Validators.required],
      noOfRepetition: [intData?.noOfRepetition || '', Validators.required],
      paymentFreqncy: [intData?.paymentFreqncy || '', Validators.required],
      interpolationOfStub: [intData?.interpolationOfStub || ''],
      firstPaymentDate: [intData?.firstPaymentDate ? new Date(intData?.firstPaymentDate) : ''],
      firstResetDate: [intData?.firstResetDate ? new Date(intData?.firstResetDate) : ''],
      floatPaymentSchedule: this.formBuilder.array([])
    });
    if (this.swapType == 'FLFX' || (this.swapType == 'FLFL' && this.interestPayRec == 'pay')) {
      this.floatInterestPayRecForm.controls.irsIntrstFltPayblId = this.formBuilder.control(intData?.irsIntrstFltPayblId);
      this.fgd.form.controls.floatInterestPayable = this.floatInterestPayRecForm;
      this.floatInterestFormGroupName = 'floatInterestPayable';
      this.fgd.form.controls.fixedInterestPayable = this.formBuilder.group({});
      this.fgd.form.controls.floatInterestPayable.updateValueAndValidity();
      this.fgd.form.controls.fixedInterestPayable.updateValueAndValidity();
    } else if (this.swapType == 'FXFL' || (this.swapType == 'FLFL' && this.interestPayRec == 'receive')) {
      this.floatInterestPayRecForm.controls.irsIntrstFltRecId = this.formBuilder.control(intData?.irsIntrstFltRecId);
      this.fgd.form.controls.floatInterestReceivable = this.floatInterestPayRecForm;
      this.floatInterestFormGroupName = 'floatInterestReceivable';
      this.fgd.form.controls.fixedInterestReceivable = this.formBuilder.group({});
      this.fgd.form.controls.floatInterestReceivable.updateValueAndValidity();
      this.fgd.form.controls.fixedInterestReceivable.updateValueAndValidity();
    }
    if (this.action == 'new' && changes.currencyCode) {
      this.floatInterestPayRecForm.controls.floatRateBenchMark.setValue('');
      this.floatInterestPayRecForm.controls.designatedMaturity.setValue('');
      this.benchmarkList = [];
      this.cdref.detectChanges();
      $('.selectpicker').selectpicker('refresh');
      this.benchmarkList = this.currencyList.find(data => data.currencyCode == this.currencyCode)?.irsCurrencyBenchmarkList || [];
      this.dropDownData.benchmarkList = this.benchmarkList.map(data=>data.benchmarkRates);
      this.cdref.detectChanges();
      $('.selectpicker').selectpicker('refresh');
    }
    this.paymentData = this.irsFormData[this.floatInterestFormGroupName]?.floatPaymentSchedule;
    if (this.action == 'reversal' || this.action == 'view') {
      this.floatInterestPayRecForm.disable();
    }

    this.fgd.form.updateValueAndValidity();
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  get g() { return this.floatInterestPayRecForm.controls; }

  reset() {
    this.floatInterestPayRecForm.reset();
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  onSubmit() {
    this.formUpdateInt.emit({ formData: <FormGroup>this.floatInterestPayRecForm, interestPayRec: this.interestPayRec });
  }

  detectChange() {
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  onChangeBenchmark() {
    this.designatedMaturityList = this.benchmarkList.find(data => data.benchmarkRates == this.g.floatRateBenchMark.value)?.designatedMarturities?.split(",") || [];
    this.dropDownData.designatedMaturityList = this.designatedMaturityList;
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  formUpdate(event: { formData: FormArray }) {
    if (this.floatInterestFormGroupName == 'floatInterestPayable') {
      this.fgd.form.controls.floatInterestPayable['controls'].floatPaymentSchedule = event.formData;
      this.fgd.form.controls.floatInterestPayable.updateValueAndValidity();
      if ((<FormArray>this.fgd.form.controls.floatInterestPayable['controls'].floatPaymentSchedule).controls.length > parseInt(this.g.noOfRepetition.value)) {
        this.toastr.warning("Payment schedule not exceed number of repetitions")
      }
    } else if (this.floatInterestFormGroupName == 'floatInterestReceivable') {
      this.fgd.form.controls.floatInterestReceivable['controls'].floatPaymentSchedule = event.formData;
      this.fgd.form.controls.floatInterestReceivable.updateValueAndValidity();
      if ((<FormArray>this.fgd.form.controls.floatInterestReceivable['controls'].floatPaymentSchedule).controls.length > parseInt(this.g.noOfRepetition.value)) {
        this.toastr.warning("Payment schedule not exceed number of repetitions")
      }
    }
    this.floatInterestPayRecForm.controls.floatPaymentSchedule = event.formData;
    this.floatInterestPayRecForm.controls.floatPaymentSchedule.updateValueAndValidity();
    this.floatInterestPayRecForm.updateValueAndValidity();
    this.fgd.form.updateValueAndValidity();
    this.cdref.detectChanges();
    this.onSubmit();
  }

  getCurrencyList() {
    this.rateService.getCurrencyBenchmarkRates().pipe(
      catchError((error: any) => {
        this.toastr.error(this.config.failureResponse["SOMETHING_WENT_WRONG"]);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.currencyList = response.data;
        this.benchmarkList = this.currencyList.find(data => data.currencyCode == this.fgd.form.controls.notionalCrncyCode.value)?.irsCurrencyBenchmarkList || [];
        this.cdref.detectChanges();
        $('.selectpicker').selectpicker('refresh');
      } else {
        this.currencyList = [];
        this.cdref.detectChanges();
        $('.selectpicker').selectpicker('refresh');
      }
    })
  }

  getPaymentSchedule() {
    if (this.g.effectiveDate.value && this.g.noOfRepetition.value && this.g.paymentFreqncy.value && this.fgd.form.controls.crncyImpctHoliday.value) {
      let requestObject = {
        "startDate": this.g.effectiveDate.value,
        "repetitions": this.g.noOfRepetition.value,
        "frequency": this.g.paymentFreqncy.value,
        "crncyImpctHoliday": this.fgd.form.controls.crncyImpctHoliday.value?.toString() || ''
      }
      this.rateService.getPaymentSchedule(requestObject).pipe(
        catchError((error: any) => {
          this.toastr.error(this.config.failureResponse["SOMETHING_WENT_WRONG"]);
          if (error.status != 200) {
            return throwError(error.error);
          }
        })
      ).subscribe((response: any) => {
        if (response.statusCode == 200) {
          response.data.forEach(data => { data.benchmark = this.g.floatRateBenchMark.value; data.designatedMaturity = this.g.designatedMaturity.value })
          this.irsFormData[this.floatInterestFormGroupName].floatPaymentSchedule = response.data;
          this.paymentData = response.data;
          this.cdref.detectChanges();
        } else {
          this.toastr.error(response.message);
        }
      })
    }
  }

  stubChange() {
    if (this.g.stub.value == 'Y') {
      this.g.interpolationOfStub.addValidators(Validators.required);
      this.g.firstPaymentDate.addValidators(Validators.required);
      this.g.firstResetDate.addValidators(Validators.required);
    } else {
      this.g.interpolationOfStub.removeValidators(Validators.required);
      this.g.firstPaymentDate.removeValidators(Validators.required);
      this.g.firstResetDate.removeValidators(Validators.required);
    }
    this.g.interpolationOfStub.updateValueAndValidity();
    this.g.firstPaymentDate.updateValueAndValidity();
    this.g.firstResetDate.updateValueAndValidity();
  }
}
